import { z } from "zod/v4-mini";

import { ContactType } from "@/models/ContactModel.ts";
import { cz } from "@/utils/zodUtils.ts";

export const contactTypes = ["nurse", "helper", "family", "unknown"] satisfies ContactType[];

export const contactFormSchema = z.object({
  phone: z.string({ error: "form.required" }),
  firstName: cz.optional(z.string({ error: "form.text.firstnameRequired" })),
  lastName: cz.optional(z.string({ error: "form.text.lastnameRequired" })),
  email: cz.optional(z.email()),
  comment: cz.optional(z.string()),
  isEmergencyContact: z.boolean({ error: "form.required" }),
  contactType: z.literal(contactTypes, {
    error: "form.required",
  }),
});

export type ContactData = z.infer<typeof contactFormSchema>;
